import { type HTMLArkProps, ark } from '@ark-ui/react';

import type { Scale9 } from '../../lib/types';
import { cn } from '../../lib/utils';

type TextElement = 'span' | 'p' | 'div' | 'label';

type TextColor = 'current' | 'gray' | 'red' | 'gold' | 'green' | 'orange';

type TextProps = Omit<HTMLArkProps<'span'>, 'color'> & {
	size?: Scale9;
	weight?: 'light' | 'regular' | 'medium' | 'bold';
	color?: TextColor;
	align?: 'left' | 'center' | 'right';
	as?: TextElement;
};

function Text({
	className,
	size = '2',
	weight = 'regular',
	color,
	align,
	as: Tag = 'span',
	...props
}: TextProps) {
	const Component = ark[Tag] as typeof ark.span;

	return (
		<Component
			data-slot="text"
			data-size={size}
			data-weight={weight}
			data-accent-color={color !== 'current' ? color : undefined}
			data-align={align}
			className={cn('pt-text', className)}
			{...props}
		/>
	);
}

export { Text, type TextProps };
